import { errorInfoOf } from "@fox1ck-org/auth/saas";
import type { PortFieldState, PortRef } from "@fox1ck-org/ui/saas";

/**
 * The tracker's `domains` port (catalog tracker.yaml, capability
 * domains.attach.v1) as «Подключить домен» draws it. Two answers meet here:
 * console's (`usePorts` — what closes the port, locked or not, which module
 * the org could add) and the tracker's own (`GetDomainPort` — the adapter a
 * new domain goes through right now, what it can do). The tracker's wins for
 * what happens on submit; console's gives the words and the way to connect.
 * Pure.
 */

/** The port's name in the catalog. */
export const DOMAINS_PORT = "domains";

/** The tracker's answer: a module attaches the name, or a person sets the records. */
export type DomainPortKind = "native" | "manual";

/** The org's `domains` port among console's ports of the tracker, if console has it. */
export function domainsPortOf(ports: readonly PortRef[]): PortRef | undefined {
  return ports.find((p) => p.port === DOMAINS_PORT);
}

/**
 * The field's state: the tracker could not use the port → `no-answer`; a
 * module attaches → `module` (`locked` when the edition keeps it, `own` for
 * the customer's service); manual → the input, `no-rights` for a person who
 * may not change the connection.
 */
export function domainFieldState(input: { kind?: string; port?: PortRef; canEdit: boolean; failed: boolean }): PortFieldState {
  if (input.failed) return "no-answer";
  if (input.kind === "native") {
    if (input.port?.adapter?.kind === "connector") return "own";
    return input.port?.locked ? "locked" : "module";
  }
  return input.canEdit ? "not-connected" : "no-rights";
}

/** Why GetDomainPort refused: the ErrorInfo reason, else null. */
export function domainPortRefusal(err: unknown): string | null {
  return errorInfoOf(err)?.reason ?? null;
}

/**
 * The host a registrar's form asks for, given what the person typed: the
 * record's `@` is the typed name itself; nothing typed yet — `@`.
 */
export function recordHostFor(fqdn: string, name: string): string {
  const typed = fqdn.trim().toLowerCase();
  if (!name || name === "@") return typed || "@";
  return typed ? `${name}.${typed}` : name;
}
